export const getCustomerColumnWidths = (screenWidth: number) => {
    const orderInRowCount = Math.floor(screenWidth / 75)

    const firstColumnOrderInRowCount = Math.ceil((orderInRowCount * 60) / 100)
    const secondColumnOrderInRowCount = Math.floor((orderInRowCount * 40) / 100)

    const firstColumnWidth = (screenWidth * firstColumnOrderInRowCount) / orderInRowCount
    const secondColumnWidth = (screenWidth * secondColumnOrderInRowCount) / orderInRowCount

    return { firstColumnWidth, secondColumnWidth }
}
